<div class="collapse mb-8" id="collapseExample">
  <form (submit)="filterList($event)">
    <div class="row">
      <div
        *ngFor="let filter of filters"
        class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3"
      >
        <label [for]="filter.label" class="form-label">{{
          filter.label | translate
        }}</label>
        <div class="position-relative">
          <div [ngSwitch]="filter.type">
            <!-- Input -->
            <input
              *ngSwitchCase="'input'"
              [(ngModel)]="filter.value"
              type="text"
              class="form-control"
              [id]="filter.label"
              [name]="filter.label"
              [placeholder]="filter.placeholder | translate"
            />

            <!-- Date -->
            <input
              *ngSwitchCase="'date'"
              [(ngModel)]="filter.value"
              type="text"
              class="form-control"
              [id]="filter.label"
              [name]="filter.label"
              bsDatepicker
              appDateFormat
              [placeholder]="filter.placeholder | translate"
              #dp="bsDatepicker"
              [bsConfig]="{
                isAnimated: true,
                dateInputFormat: 'DD-MM-YYYY',
                maxDate: maxDate,
                containerClass: 'theme-orange custom-datepicker'
              }"
            />

            <!-- Select -->
            <select
              *ngSwitchCase="'select'"
              [(ngModel)]="filter.value"
              class="form-select"
              [id]="filter.label"
              [name]="filter.label"
            >
              <option [ngValue]="null" disabled selected>
                {{ filter.placeholder | translate }}
              </option>
              <option
                *ngFor="let option of getOptions(filter.label)"
                [value]="option.id"
              >
                {{ getFilterOptionName(option) }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Filter Buttons -->
      <div
        [ngClass]="isUserList ? 'col-xl-4' : 'col-xl-2'"
        class="text-end filter-btn mt-2 d-flex align-items-center gap-4 justify-content-end mt-5"
      >
        <button
          (click)="clearFilters()"
          type="button"
          class="btn btn-secondary cursor-pointer"
        >
          {{ "clear" | translate }}
        </button>
        <button type="submit" class="btn btn-primary cursor-pointer">
          {{ "filter" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
